import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';

export const ModulesTab = ({ modules, licenseType, onBuyClick }) => {
  const { t } = useLanguage();
  const isDemo = licenseType === 'demo';

  return (
    <div>
      <div className="dash-title-block">
        <h2 className="dash-title">{t('dashboard.modulesTitle')}</h2>
      </div>
      <div className="showcase-grid">
        {modules.map((mod) => {
          const moduleData = t(`modules.${mod.id}`);
          
          return (
            <div key={mod.id} className="cyber-panel module-card">
              <div className="module-card-header">
                <h4 className="module-title">{moduleData.name}</h4>
                <span className="module-price">{isDemo ? t('dashboard.free') || 'Free' : mod.price}</span>
              </div>
              
              <ul className="module-features">
                {moduleData.features && moduleData.features.map((feature, index) => (
                  <li key={index}>
                    <i className="fas fa-check-circle"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="module-actions">
                <button 
                  className="cyber-action-btn module-buy-btn"
                  onClick={() => onBuyClick(mod)}
                  disabled={mod.owned}
                  style={{
                    background: mod.owned ? '#2d3748' : (isDemo ? '#10b981' : '#8b5cf6'),
                    color: mod.owned ? '#6b7280' : '#fff',
                    cursor: mod.owned ? 'not-allowed' : 'pointer',
                    opacity: mod.owned ? 0.6 : 1,
                    width: '100%',
                    padding: '10px',
                    fontSize: '14px',
                    fontWeight: '700',
                    borderRadius: '8px',
                    border: 'none',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {mod.owned ? (
                    <>
                      <i className="fas fa-check-double"></i> {t('dashboard.installed')}
                    </>
                  ) : isDemo ? (
                    <>
                      <i className="fas fa-plus-circle"></i> {t('dashboard.activateFree') || 'Activate Free'}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-shopping-cart"></i> {t('dashboard.buy')}
                    </>
                  )}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};